"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = typesAliasFromDefs;

var _lodash = _interopRequireDefault(require("lodash.merge"));

function typesAliasFromDefs(definitions, initAlias) {
  if (initAlias === void 0) {
    initAlias = {};
  }

  return Object.values(definitions).reduce((res, _ref) => {
    let {
      typesAlias
    } = _ref;
    return (0, _lodash.default)({}, typesAlias, res);
  }, initAlias);
}